<nav class="navbar navbar-expand-lg navbar-light mb-3">
    <a class="navbar-brand" href="#">
        <img src="assets/icons/home-icon.svg" alt="">
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav">
            <li class="nav-item" *ngIf="women">
                <a class="nav-link f-14 font-weight-medium" href="#">Women </a>
            </li>
            <li class="nav-item" *ngIf="men">
                <a class="nav-link f-14 font-weight-medium" href="#">Women </a>
            </li>
            <li class="nav-item">
                <a class="nav-link f-14 font-weight-medium" href="#">Shoes</a>
            </li>
            <li class="nav-item">
                <a class="nav-link f-14 font-weight-medium" href="#">Puma</a>
            </li>
            <li class="nav-item active" *ngIf="women">
                <a class="nav-link f-14 font-weight-medium" href="#">Track Jacket
                    <span class="sr-only">(current)</span></a>
            </li>

            <li class="nav-item active" *ngIf="men">
                <a class="nav-link f-14 font-weight-medium" href="#">Sneakers
                    <span class="sr-only">(current)</span></a>
            </li>
        </ul>
    </div>
</nav>